<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
                class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

        <div class="mt-6 flex items-center justify-between px-6">
            <div class="flex">
                <h4>ETAPA </h4><h4 v-if="licitacionProp!==undefined">  ({{ licitacionProp.IDLICITACION }})</h4>
            </div>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>

        <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

            <div class="p-6">
<!--                <component v-bind:is="'EtapaCasoEdit'" :etapaLicitacionData="data" @changeMode="activateEditMode" @closeView="closeSidebar" @refresh="refreshData"></component>-->

                <etapa-caso-view v-if="modeView" :etapaData="data" @changeMode="activateEditMode" @closeView="closeSidebar" @refresh="refreshData"/>
                <etapa-caso-edit v-if="!modeView" :licitacionProp="licitacionProp" :propEtapaData="data" @closeEdit="closeSidebar" @refresh="refreshData" />

            </div>
        </component>

    </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EtapaCasoView from '@/views/etapa-caso/EtapaCasoView.vue'
import EtapaCasoEdit from '@/views/etapa-caso/EtapaCasoEdit.vue'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    propModeView: { // Si es modo ver, se incluye el EtapaCasoView, sino EtapaCasoEdit
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: () => {
      }
    },
    licitacionProp: {
      type: Object,
      default: () => {

      }
    }
  },
  components: {
    VuePerfectScrollbar,
    EtapaCasoView,
    EtapaCasoEdit
  },
  data () {
    return {
      modeView: true, // Lo mismo que propModeView pero para no sobreescribir
      dataId: null,
      dataName: '',
      dataCategory: null,
      dataImg: null,
      dataOrder_status: 'pending',
      dataPrice: 0,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  created () {
  },
  mounted () {
    this.modeView = this.propModeView
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        //this.$validator.reset()
      } else {
        const {category, id, img, name, order_status, price} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.dataImg = img
        this.dataName = name
        this.dataOrder_status = order_status
        this.dataPrice = price
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataCategory && this.dataPrice > 0
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    activateEditMode () {
      this.modeView = false
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataCategory = null
      this.dataOrder_status = 'pending'
      this.dataPrice = 0
      this.dataImg = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataName,
            img: this.dataImg,
            category: this.dataCategory,
            order_status: this.dataOrder_status,
            price: this.dataPrice
          }

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('dataList/updateItem', obj).catch(err => {
              console.error(err)
            })
          } else {
            delete obj.id
            obj.popularity = 0
            this.$store.dispatch('dataList/addItem', obj).catch(err => {
              console.error(err)
            })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    closeSidebar () {
      this.$emit('closeSidebar')
      this.$validator.reset()
      this.initValues()
    },
    refreshData () {
      this.$emit('refresh')
      this.$emit('closeSidebar')
      this.$validator.reset()
      this.initValues()
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 51002;
    }

    ::v-deep .vs-sidebar {

      z-index: 51002;
      width: 90%;
      height: 95%;
      max-width: 1000vw;
      max-height: 1000vw;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0; 
      right: 0; 
      margin-top: auto; 
      margin-bottom: auto; 
      margin-left: auto; 
      margin-right: auto; 

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: 90%;

    &:not(.ps) {
      overflow-y: auto;
    }
  }

</style>
